export const chevronDownIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8.02 11a1 1 0 0 0 .706-.29l3.981-3.997a1.006 1.006 0 0 0-.448-1.679 1 1 0 0 0-.965.26L8.02 8.602 4.735 5.424a.993.993 0 0 0-1.712.454c-.08.366.051.746.339.985l3.98 3.857a1 1 0 0 0 .678.28"/></svg>`,
    name: 'chevron-down'
};